module.exports = __webpack_public_path__ + "static/q6answer4_shabbychic_wishmas-4cf06c45a1119559de609fbd8056e6f8.jpg";